import React from 'react';
import useEducators from './useEducators';

export default function useSleepingPartners(state, network, schoolStart, schoolEnd, currentTimestamp) {
  return useEducators(state, network, schoolStart, schoolEnd, {
    sleepingStartingAt: {
      $lte: currentTimestamp
    },
    sleepingEndingAt: {
      $gte: currentTimestamp
    },
    inactive: false
  });
}
